"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const native_base_1 = require("native-base");
const icons_1 = require("@native-base/icons");
const getLastClaim_1 = __importDefault(require("./storage/getLastClaim"));
const getUser_1 = require("./auth/getUser");
const SapporoClaimView_1 = __importDefault(require("./SapporoClaimView"));
const ClaimSapporoForm_1 = __importDefault(require("./ClaimSapporoForm"));
//import analytics from '@react-native-firebase/analytics';
const Splash_1 = __importDefault(require("./Splash"));
const SapporoBannerAd_1 = __importDefault(require("./SapporoBannerAd"));
const getUser_2 = require("./auth/getUser");
const LocationView_1 = require("./LocationView");
const Firebase_1 = require("./Firebase");
const native_base_2 = require("native-base");
const Dashboard = ({ appIsActive, getUIComponents, getImage, victory, getLocationView, getLocationViewWithEdit, }) => {
    const toast = (0, native_base_1.useToast)();
    const firebase = (0, react_1.useContext)(Firebase_1.FirebaseContext);
    const user = (0, react_1.useContext)(getUser_2.UserContext);
    const location = (0, react_1.useContext)(LocationView_1.LocationContext) || {
        latitude: 45,
        longitude: -93,
    };
    const UI = getUIComponents();
    //   const message = React.useContext(MessageContext);
    const actionListener = (status, message) => {
        setTimeout(() => {
            toast.show({
                title: status,
                description: message,
                placement: 'top',
            });
        }, 400);
    };
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [loadingLocation, setLoadingLocation] = (0, react_1.useState)(false);
    const [loadingClaims, setLoadingClaims] = (0, react_1.useState)(true);
    const message = undefined;
    const getCurrentClaim = (claim, sapporoUser) => {
        if (!claim) {
            return (react_1.default.createElement(native_base_1.VStack, { flex: 1, space: 3, rounded: "lg", m: "5", p: "5", bg: UI.background, alignItems: "center" }, loading && (react_1.default.createElement(native_base_1.Spinner, { size: "lg", accessibilityLabel: "Loading posts", color: "#FFD51C" }))));
        }
        else {
            return (react_1.default.createElement(native_base_1.Box, { flex: 1, pl: 5, alignContent: 'center', justifyContent: 'center' },
                react_1.default.createElement(native_base_1.Center, null,
                    react_1.default.createElement(native_base_1.Heading, { pb: 5, pt: 5, size: "lg", color: "white", fontFamily: 'Montserrat' }, "Current Sapporo Claim")),
                react_1.default.createElement(native_base_1.VStack, { rounded: "lg", m: 3, p: 3, flex: 1, bg: "white" },
                    react_1.default.createElement(native_base_1.ScrollView, { flex: 1, bg: 'white', _contentContainerStyle: {
                            alignContent: 'center',
                            justifyContent: 'center',
                        } },
                        react_1.default.createElement(SapporoClaimView_1.default, { passedUser: sapporoUser, victory: victory, getLocationView: getLocationView, getUIComponents: getUIComponents, getImage: getImage, active: appIsActive, claim: claim, refreshClaim: refreshClaim })))));
        }
    };
    const [showClaimSapporo, setShowClaimSapporo] = (0, react_1.useState)(false);
    //const [location, setLocation] = useState<GeoPosition | undefined>(undefined);
    const [hasTriedLocation, setHasTriedLocation] = (0, react_1.useState)(true);
    const [currentClaim, setCurrentClaim] = (0, react_1.useState)(undefined);
    const refreshClaim = () => __awaiter(void 0, void 0, void 0, function* () {
        const curr = yield (0, getLastClaim_1.default)(firebase, user ? user.uid : undefined);
        setCurrentClaim(curr);
        return curr;
    });
    const logDeviceData = (sappUser, location) => __awaiter(void 0, void 0, void 0, function* () {
        yield (0, getUser_1.exportInstallData)(firebase, sappUser, location);
    });
    (0, react_1.useEffect)(() => {
        const runUpdate = () => __awaiter(void 0, void 0, void 0, function* () {
            if (user && hasTriedLocation) {
                setLoadingClaims(true);
                setLoading(loading || true);
                logDeviceData(user, location);
                yield refreshClaim();
                setLoading(false || loadingLocation);
            }
        });
        runUpdate();
    }, [user]); // [user, location, hasTriedLocation]
    // useEffect(() => {
    //   console.log('Watch position');
    //   setLoadingLocation(true);
    //   setLoading(true);
    //   AsyncStorage.getItem('@sapporo-no-location').then(result => {
    //     console.log('Asking permission', result);
    //     if (!result || result !== 'true') {
    //       Geolocation.watchPosition(
    //         async position => {
    //           console.log(
    //             'Updated Pos',
    //             position.coords.latitude,
    //             position.coords.longitude,
    //           );
    //           setLocation(position);
    //           setHasTriedLocation(true);
    //           if (loadingLocation) {
    //             setLoadingLocation(false);
    //             setLoading(false || loadingClaims);
    //           }
    //         },
    //         error => {
    //           // See error code charts below.
    //           console.log(error.code, error.message);
    //           if (loading) {
    //             setLoadingLocation(false);
    //             setHasTriedLocation(true);
    //             setLoading(false || loadingClaims);
    //           }
    //         },
    //       );
    //     } else {
    //       console.log('NOT ASKING FOR LOCATION', loading);
    //       setLoadingLocation(false);
    //       setHasTriedLocation(true);
    //       if (loading) {
    //         setLoading(false || loadingClaims);
    //       }
    //     }
    //   });
    //   return () => {
    //     Geolocation.stopObserving();
    //   };
    // }, []);
    if ((loading && !currentClaim) || !user) {
        return (react_1.default.createElement(Splash_1.default, { h: '750', w: '500', getUIComponents: getUIComponents, getImage: getImage, spinner: true }));
    }
    return (react_1.default.createElement(native_base_1.Box, { flex: 1, width: "100%", pb: 5, bg: UI.background, alignItems: "center", justifyContent: "center" },
        getCurrentClaim(currentClaim, user),
        react_1.default.createElement(ClaimSapporoForm_1.default, { asModal: true, victory: victory, getUIComponents: getUIComponents, getImage: getImage, user: user, actionListener: actionListener, showClaimSapporo: showClaimSapporo, setShowClaimSapporo: setShowClaimSapporo, getLocationViewWithEdit: getLocationViewWithEdit }),
        react_1.default.createElement(native_base_2.HStack, { space: 5 },
            react_1.default.createElement(native_base_1.Button, { mt: "5", colorScheme: "secondary", mb: "5", _text: {
                    fontFamily: 'Montserrat',
                }, leftIcon: react_1.default.createElement(native_base_1.Icon, { as: icons_1.Entypo, name: "flow-cascade", size: "sm" }), onPress: () => {
                    setShowClaimSapporo(!showClaimSapporo);
                } }, "Claim The Sapporo")),
        react_1.default.createElement(SapporoBannerAd_1.default, { location: "dashboard" })));
};
exports.default = Dashboard;
/**
 *       <Button
        mt="5"
        mb="5"
        _text={{
          fontFamily: 'Montserrat',
        }}
        color
        leftIcon={<Icon as={Entypo} name="flow-cascade" size="sm" />}
        onPress={() => {
          setShowClaimSapporo(!showClaimSapporo);
        }}
        >
        Sapporo History
      </Button>

 */
